import React from 'react';

function LoadingProgress() {
  return (
    <section id="loading-progress" className="text-center mt-32">
      <h2 className="text-6xl md:text-7xl font-medium">
        Loading...
      </h2>
    </section>
  );
}

export default LoadingProgress;
